export default {
    // 获取小程序跳转地址
    generateUrlLink: "/gateway/manageBedrock/wechatcs/generateUrlLink",
};



// WEBPACK FOOTER //
// ./src/transferQr/api.js